import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { loadPeriodos } from '../../store/actions/Periodos';

import Grid from '@material-ui/core/Grid';
import EditIcon from '@material-ui/icons/Edit';
import ReceiptIcon from '@material-ui/icons/Receipt';
import AccountBalanceWalletOutlinedIcon from '@material-ui/icons/AccountBalanceWalletOutlined';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Paper from '@material-ui/core/Paper';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import WarningIcon from '@material-ui/icons/Warning';
import ReportIcon from '@material-ui/icons/Report';
import AssignmentIcon from '@material-ui/icons/Assignment';
import AssignmentLateIcon from '@material-ui/icons/AssignmentLate';
import SchoolIcon from '@material-ui/icons/School';
import RoomIcon from '@material-ui/icons/Room';
import PaymentIcon from '@material-ui/icons/Payment';
import DescriptionIcon from '@material-ui/icons/Description';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import Typography from '@material-ui/core/Typography';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Avatar from '@material-ui/core/Avatar';
import { green, amber, orange, blue, red, grey } from '@material-ui/core/colors';

import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import Toast from '../../components/Toast/Toast';
import { ButtonPrimary, ButtonDefault } from "../../components/Button/Button";
import Loading from '../../components/Loading/Loading';
import DashboardCard from '../../components/Dashboard/DashboardCard';
import PainelProva from './PainelProva';

import DialogChangePassword from '../../forms/Dialog/DialogChangePassword'
import DialogFinalizarInscricao from '../../forms/Dialog/DialogFinalizarInscricao';

import DashboardService from '../../services/Dashboard';
import CandidatoService from "../../services/Candidato";
import { errors } from '../../services/API';

import { 
  isInscricoesAbertas, 
  isPeriodoConfirmacao, 
  isPeriodoPagamento,
  getDataDaProvaFormatado,
  isPeriodoDivulgacaoLocalProva,
  isPeriodoDivulgacaoNotas,
} from '../../helper/ContextHelper';
import { locationCandidatoParse } from '../../helper/ParseStateHelper';

import Alertas from './Alertas';

import { Layout } from '../../layouts/private/Private';

export class Dashboard extends Component {
  constructor() {
    super()
    this.alertasRef = React.createRef();
    this.state = {
      candidato: {
        id: null,
        cpf: null,
        inscricaoFinalizada: false,
        dataFinalizacaoInscricao: null,
        comLocalProvaEscolhido: false,
        comLocalProvaConfirmado: false,
        comEscolaAtuacao: false,
        comEscolaValida: false,
        comEscolaInvalida: false,
        comMatriculaValida: false,
        comMatriculaInvalida: false,
        podeFinalizarInscricao: false,
        precisaRealizarPagamento: false,
        pagamentoEmAndamento: false,
        pagamentoConfirmado: false,
        podeGerarRecibo: false,
        localProva: null,
        sabatista: false,
      },
      loading: true,
    }
  }

  setToast = t => this.Toast = t;
  setDialogChangePassword = p => this.DialogChangePassword = p;
  setDialogFinalizarInscricao = d => this.DialogFinalizarInscricao = d;

  handleOpenDialogChangePassword = () => this.DialogChangePassword.setState({ open: true, id: this.state.candidato.id, login: this.state.candidato.cpf });
  handleOpenDialogFinalizarInscricao = () => {
    this.DialogFinalizarInscricao.openModal(
      this.state.candidato.dataFinalizacaoInscricao, 
      this.state.candidato.precisaRealizarPagamento,
      this.state.candidato.pagamentoConfirmado
    )
  };

  handleFinalizarInscricao = () => {
    CandidatoService.finalizarInscricao(this.state.candidato.id)
      .then(() => {
        this.Toast.setState({
          message: {
            message: "Inscrição Finalizada com Sucesso!",
            type: "success",
            open: true
          }
        });
        this.DialogFinalizarInscricao.setState({ open: false });
        this.carregarDashboard();
        this.carregarAlertas();
      })
      .catch(error => {
        const e = errors(error);
        this.Toast.setState({
          message: {
            message: e.message,
            type: e.type,
            open: true
          }
        });
      })
      .finally(() => {
        this.DialogFinalizarInscricao.setState({ loading: false });
      });
  }

  componentDidMount() {
    this.carregarDashboard();
  }

  carregarAlertas = () => {
    this.alertasRef.current.recarregar(this.state.candidato.id);
  }
  
  carregarDashboard = async () => {
    this.props.loadPeriodos();

    const f = locationCandidatoParse(this.props.location);

    await DashboardService.init(f)
      .then(async (res) => {
        await CandidatoService.find(res.data.id)
          .then(() => {
            this.setState({
              candidato: {
                id: res.data.id,
                nome: res.data.nomeExibicao,
                cpf: res.data.cpf,                
                inscricaoFinalizada: res.data.dataFinalizacaoInscricao != null,
                dataFinalizacaoInscricao: res.data.dataFinalizacaoInscricao,
                comLocalProvaEscolhido: res.data.localProvaOriginal != null,
                comLocalProvaConfirmado: res.data.localProvaFinal != null,
                comEscolaAtuacao: res.data.escola != null,
                comEscolaValida: res.data.escola ? res.data.escola.valida : false,
                comEscolaInvalida: res.data.escola ? res.data.escola.invalida : false,
                comMatriculaValida: res.data.matricula ? res.data.matricula.validacao.valido : false,
                comMatriculaInvalida: res.data.matricula ? res.data.matricula.validacao.invalido : false,
                podeFinalizarInscricao: res.data.podeFinalizarInscricao,
                precisaRealizarPagamento: res.data.precisaRealizarPagamento,
                pagamentoEmAndamento: res.data.pagamentoEmAndamento,
                pagamentoConfirmado: res.data.pagamentoConfirmado,
                podeGerarRecibo: res.data.podeGerarRecibo,
                localProva: res.data.localProva,
                sabatista: res.data.sabatista,
              }
            });    
          })
          .catch(error => {
            const e = errors(error);
            this.Toast.setState({
              message: {
                message: e.message,
                type: e.type,
                open: true
              }
            })
          })
          .finally(() => this.setState({ loading: false }));
      })
      .catch(error => {
        const e = errors(error);
        this.Toast.setState({
          message: {
            message: e.message,
            type: e.type,
            open: true
          }
        })
      })      
  }

  render() {
    const { loading, candidato } = this.state;
    const { contexts } = this.props;

    const localProva = candidato.localProva || {};

    const page = 'Dashboard';
    const links = [
      {
        path: null,
        name: `${this.state.candidato.nome}`
      }
    ];

    const isPodeEditarDados = isInscricoesAbertas(contexts) && !candidato.inscricaoFinalizada;

    const redirecionaParaSisPag = (id) => {
      CandidatoService.buscaUrlDePagamento(id)
        .then(resultado => window.location.href = resultado.data)
        .catch(() => {
          this.Toast.setState({
            message: {
              message: "Ocorreu um erro, por favor tente novamente.",
              type: "error",
              open: true
            }
          })
        });
    }

    const redirecionaParaSisPagDadosPagamento = (id) => {
      CandidatoService.buscaUrlDeDadosDoPagamento(id)
        .then(resultado => window.location.href = resultado.data)
        .catch(() => {
          this.Toast.setState({
            message: {
              message: "Ocorreu um erro, por favor tente novamente.",
              type: "error",
              open: true
            }
          })
        });
    }

    const steps = [
      { 
        label: 'Ficha de Inscrição', 
        completed: true, 
        path: `/admin/inscricao/${candidato.cpf}/editar` 
      },
      { 
        label: `${candidato.comEscolaAtuacao && !candidato.comEscolaValida && !candidato.comEscolaInvalida ? "Aguardando Validação de" : "" } Escola de Atuação 
                  ${candidato.comEscolaValida ? "Aceita pela OBMEP" : candidato.comEscolaInvalida ? "Reprovada pela OBMEP" : "" }`, 
        completed: candidato.comEscolaAtuacao, 
        error: candidato.comEscolaInvalida,
        pending: candidato.comEscolaAtuacao && !candidato.comEscolaValida && !candidato.comEscolaInvalida, 
        path: `/admin/inscricao/${candidato.id}/escola-atuacao` 
      },
      { 
        label: 'Local de Prova', 
        completed: candidato.comLocalProvaEscolhido, 
        path: `/admin/inscricao/${candidato.id}/local-prova` 
      },
      ...(candidato.comEscolaAtuacao ? [{ 
        label: `${!candidato.comMatriculaValida && !candidato.comMatriculaInvalida ? "Aguardando Validação de" : "" } Comprovante de Vínculo com 
                  a Escola ${candidato.comMatriculaValida ? "Aceito pela OBMEP" : candidato.comMatriculaInvalida ? "Reprovado pela OBMEP" : "" }`, 
        completed: candidato.comMatriculaValida, 
        error: candidato.comMatriculaInvalida,
        pending: !candidato.comMatriculaValida && !candidato.comMatriculaInvalida,
        path: `/admin/inscricao/${candidato.id}/escola-atuacao`
      }] : []),
      ...(candidato.precisaRealizarPagamento ? [{ 
        label: 'Pagamento', 
        completed: candidato.pagamentoConfirmado,
        path: isPeriodoPagamento(contexts) && candidato.comEscolaValida && candidato.comMatriculaValida && candidato.comLocalProvaEscolhido && !candidato.pagamentoEmAndamento ? `/admin/inscricao/${candidato.id}/pagamento/fatura` : null,
        onClick: isPeriodoPagamento(contexts) && candidato.pagamentoEmAndamento ? () => redirecionaParaSisPag(candidato.id)
                  : candidato.pagamentoConfirmado ? () => redirecionaParaSisPagDadosPagamento(candidato.id) : null
      }] : []),
      { 
        label: 'Finalização da Inscrição', 
        completed: candidato.podeGerarRecibo || (candidato.precisaRealizarPagamento && candidato.inscricaoFinalizada),
        path: candidato.podeGerarRecibo ? `/admin/inscricao/${candidato.id}/comprovante` : null,
        onClick: !candidato.podeGerarRecibo && (candidato.podeFinalizarInscricao || candidato.inscricaoFinalizada) ? () => this.handleOpenDialogFinalizarInscricao(candidato.id) : null
      },
      ...(isPeriodoConfirmacao(this.props.contexts) && candidato.inscricaoFinalizada && candidato.podeGerarRecibo ? [{ 
        label: 'Confirmação de Local de Prova', 
        completed: candidato.comLocalProvaConfirmado,
        path: `/admin/inscricao/${candidato.id}/local-prova/confirmar`
      }] : []),
    ];

    const activeStep = steps.findIndex(step => !step.completed);
    const currentStep = activeStep === -1 ? steps.length : activeStep;

    const StepIcon = (props) => {
      const { active, completed, error, pending } = props;
      
      if (error) 
        return <ReportIcon style={{ color: red[700] }} />;
      
      if (pending)
        return <AssignmentLateIcon style={{ color: orange[700] }} />;

      if (completed) 
        return <CheckCircleIcon style={{ color: green[500] }} />;
      
      if (active) 
        return <Avatar style={{ width: 24, height: 24, fontSize: 12, backgroundColor: blue[500] }}>{props.icon}</Avatar>;
      
      return <WarningIcon style={{ color: amber[700] }} />;
    };

    return (
      <Layout>
        <Toast parentRef={this.setToast} />
        <Grid container >
          <Grid item xs={12}>
            <Breadcrumbs links={links} active={page} />
          </Grid>
        </Grid>

        { loading ? 
          <Loading />
        :           
          <Grid container spacing={3} style={{ marginTop: 12 }}>            
            { (contexts && isPeriodoDivulgacaoNotas(contexts)) && 
              <Grid item xs={12}>
                <PainelProva candidatoId={candidato.id} contexts={contexts} />
              </Grid>
            }

            { (localProva.id && contexts && isPeriodoDivulgacaoLocalProva(contexts)) && 
              <Grid item xs={12}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Paper elevation={3} style={{ padding: 24, borderRadius: 12, border: '1px solid #e9ecef' }}>
                      <Typography variant="h6" style={{ fontWeight: 500, marginBottom: 12 }}>Local de Realização de Prova</Typography>

                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                          <Typography variant="body2" style={{ color: grey[700], marginBottom: 6 }}>
                            Centro de Aplicação:
                          </Typography>
                          <Typography variant="body1" style={{ fontWeight: 600, marginBottom: 12 }}>
                            {localProva.nome ?? '--'}
                          </Typography>

                          <Typography variant="body2" style={{ color: grey[700], marginBottom: 6 }}>
                            Sala:
                          </Typography>
                          <Typography variant="body1" style={{ fontWeight: 600, marginBottom: 12 }}>
                            {localProva.sala ?? '--'}
                          </Typography>

                          <Typography variant="body2" style={{ color: grey[700], marginBottom: 6 }}>
                            Endereço:
                          </Typography>
                          <Typography variant="body1" style={{ fontWeight: 600, marginBottom: 12 }}>
                            {localProva.endereco.enderecoFormatado ?? '--'}
                          </Typography>

                          <Typography variant="body2" style={{ color: grey[700], marginBottom: 6 }}>
                            Data e Hora da Prova:
                          </Typography>
                          <Typography variant="body1" style={{ fontWeight: 600 }}>
                            {contexts ? `${getDataDaProvaFormatado(contexts)} (Horário de Brasília)` : '--'}
                          </Typography>
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <Paper elevation={0} style={{ padding: 16, borderRadius: 12, backgroundColor: '#fdddfd', border: '1px solid #f099e8' }}>
                            <Typography variant="body2" style={{ fontWeight: 600, marginBottom: 10 }}>Orientações</Typography>
                            <Typography variant="body2" style={{ color: grey[800], lineHeight: 1.6 }}>
                              - As provas serão realizadas das <b>14:30h às 17:30h (Horário de Brasília)</b>, totalizando 3 horas de duração.<br />
                              - Pessoas com deficiência (Prova em Braille, prova ampliada ou com auxílio de ledor/ escrevedor/ Intérprete de Libras) terão até 4 horas para realizar a prova.<br />
                              - Compareça ao local de prova com, pelo menos, <b>30 minutos</b> de antecedência<br />
                              - É obrigatório apresentar um documento com foto e CPF.<br />
                              - Na hora da prova é permitido ter em mãos apenas lápis, borracha e caneta esferográfica azul ou preta.<br />
                              - É permitido levar lanche.
                            </Typography>
                          </Paper>
                        </Grid>

                        { candidato.sabatista &&
                          <Grid item xs={12}>
                            <Paper elevation={0} style={{ padding: 16, borderRadius: 12, backgroundColor: '#ffebc1', border: '1px solid #f7c17e' }}>
                              <Typography variant="body2" style={{ fontWeight: 600, marginBottom: 10 }}>Sabatistas</Typography>
                              <Typography variant="body2" style={{ color: grey[900], lineHeight: 1.6 }}>
                                - Compareça ao local de prova no mesmo horário (14:30h - horário de Brasília) como os demais.<br />
                                - Você será direcionado para uma sala reservada para aguardar até o pôr do sol, quando iniciará a realização da prova.<br />
                                - Durante o período de permanência na sala reservada, o candidato ficará incomunicável com o externo e não poderá utilizar nenhum meio de comunicação ou equipamento 
                                  eletrônico (telefone fixo ou celular, notebook, walkman, pager, smartphone, tablet ou quaisquer similares), nem consultar livros, códigos, manuais, notas, impressos.
                              </Typography>
                            </Paper>
                          </Grid>
                        }
                      </Grid>
                    </Paper>
                  </Grid>
                </Grid>
              </Grid>
            }

            <Grid item xs={12} md={12} lg={12}>
              <Paper elevation={3} style={{ padding: 24, borderRadius: 12, border: '1px solid #e9ecef' }}>
                <Typography variant="h6" style={{ fontWeight: 500, marginBottom: 12 }}>Dados de Inscrição</Typography>
                
                <Grid container spacing={3}>                  
                  <Grid item xs={12} md={4} lg={3}>
                    <Paper elevation={2} style={{ padding: 20 }}>
                      <Typography variant="h6" gutterBottom>Progresso da Inscrição</Typography>
                      <Stepper activeStep={currentStep} orientation="vertical" style={{ padding: '20px 0', backgroundColor: 'transparent' }}>
                        {steps.map((step, index) => ( 
                          <Step key={step.label} completed={step.completed}>
                            <StepLabel 
                              StepIconComponent={StepIcon}
                              error={step.error || (!step.completed && index < currentStep)}
                              StepIconProps={{
                                pending: step.pending
                              }}
                            >
                              {step.path ? (
                                <Link to={step.path} style={{ textDecoration: 'none' }}>
                                  <Typography 
                                    variant="body1" 
                                    style={{ 
                                      fontWeight: (currentStep === index || step.error || step.pending)? 'bold' : 'normal', 
                                      color: step.error ? red[900] : (!step.completed && index < currentStep ? amber[900] : grey[700]),
                                      cursor: 'pointer'
                                    }}
                                  >
                                    {step.label}
                                  </Typography>
                                </Link>
                              ) : step.onClick ? (
                                <Typography 
                                  variant="body1" 
                                  onClick={step.onClick}
                                  style={{ 
                                    fontWeight: (currentStep === index || step.error || step.pending) ? 'bold' : 'normal', 
                                    color: step.error ? red[900] : (!step.completed && index < currentStep ? amber[900] : grey[700]),
                                    cursor: 'pointer',
                                  }}
                                >
                                  {step.label}
                                </Typography>
                              ) : (
                                <Typography 
                                  variant="body1" 
                                  style={{ 
                                    fontWeight: (currentStep === index || step.error || step.pending) ? 'bold' : 'normal', 
                                    color: !step.completed && index < currentStep ? amber[900] : grey[700] 
                                  }}
                                >
                                  {step.label}
                                </Typography>
                              )}
                            </StepLabel>
                          </Step>
                        ))}
                      </Stepper>
                    </Paper>
                  </Grid>

                  <Grid item xs={12} md={8} lg={9}>
                    <Alertas id={candidato.id} ref={this.alertasRef} />

                    <Grid container spacing={3}>
                      <DashboardCard
                        title="Ficha de Inscrição"
                        description="Dados preenchidos no início de sua Inscrição."
                        icon={<AssignmentIcon />}
                        status="success"
                        action={
                          <ButtonPrimary
                            startIcon={<EditIcon />}
                            to={{ pathname: `/admin/inscricao/${candidato.cpf}/editar`, state: { candidato: candidato.id } }}
                            component={Link}
                            name={isPodeEditarDados ? "Editar Ficha de Inscrição" : "Ver Ficha de Inscrição"}
                            fullWidth
                          />
                        }
                      />

                      <DashboardCard
                        title="Escola de Atuação"
                        description="Informar dados de Escola de atuação e comprovante de vínculo."
                        icon={<SchoolIcon />}
                        status={
                          candidato.comEscolaAtuacao && (candidato.comEscolaInvalida || candidato.comMatriculaInvalida) ? "error" : 
                          candidato.comEscolaAtuacao && (candidato.comEscolaValida && candidato.comMatriculaValida) ? "success" :
                          candidato.comEscolaAtuacao && 
                            ((!candidato.comEscolaValida && !candidato.comEscolaInvalida) || (!candidato.comMatriculaValida && !candidato.comMatriculaInvalida)) ? "pending" 
                          : "warning"
                        }
                        action={
                          <ButtonPrimary
                            startIcon={<EditIcon />}
                            to={{ pathname: `/admin/inscricao/${candidato.id}/escola-atuacao`, state: { candidato: candidato.id } }}
                            component={Link}
                            name={isPodeEditarDados ? "Editar Dados de Escola de Atuação" : "Ver Dados de Escola de Atuação"}
                            fullWidth
                          />
                        }
                      />

                      <DashboardCard
                        title="Local de Prova"
                        description="Selecione o Município de Prova desejado dentro das opções disponíveis."
                        icon={<RoomIcon />}
                        status={candidato.comLocalProvaEscolhido ? "success" : "warning"}
                        action={
                          <ButtonPrimary
                            startIcon={<EditIcon />}
                            to={{ pathname: `/admin/inscricao/${candidato.id}/local-prova`, state: { candidato: candidato.id } }}
                            component={Link}
                            name={isPodeEditarDados ? "Escolher Local de Prova" : "Ver Local de Prova Escolhido"}
                            fullWidth
                          />
                        }
                      />

                      { (candidato.precisaRealizarPagamento && !candidato.pagamentoConfirmado && isPeriodoPagamento(contexts)) ? 
                        <>
                          { (!candidato.comMatriculaValida || !candidato.comEscolaValida || !candidato.comLocalProvaEscolhido) ?
                            <DashboardCard
                              title="Pagamento"
                              description={
                                `A Realização do Pagamento estará disponível a partir 
                                ${!candidato.comEscolaValida || !candidato.comMatriculaValida ? " da aprovação " : ""} 
                                ${!candidato.comEscolaValida ? "da Escola de Atuação" : ""} 
                                ${!candidato.comEscolaValida && !candidato.comMatriculaValida ? " e " : ""} 
                                ${!candidato.comMatriculaValida ? "do Comprovante de Vínculo com a Escola" : ""} 
                                ${!candidato.comEscolaValida || !candidato.comMatriculaValida ? ` pela OBMEP ${!candidato.comLocalProvaEscolhido ? ", e " : "." }` : ""}
                                ${!candidato.comLocalProvaEscolhido ? "da escolha do Local de Prova." : ""}`
                              }
                              icon={<PaymentIcon />}
                              status={"warning"}
                              action={
                                <ButtonPrimary
                                  disabled={true}
                                  startIcon={<AccountBalanceWalletOutlinedIcon />}
                                  component={'button'}
                                  name={"Realizar Pagamento da Inscrição"}
                                  fullWidth
                                />
                              }
                            />
                          :
                            <DashboardCard
                              title="Pagamento"
                              description={candidato.pagamentoEmAndamento ? "Acesse o Sistema de Pagamento para gerar a 2ª via do boleto." : "Preencha os dados da fatura para gerar o boleto."}
                              icon={<PaymentIcon />}
                              status={"warning"}
                              action={
                                <ButtonPrimary
                                  startIcon={<AccountBalanceWalletOutlinedIcon />}
                                  onClick={candidato.pagamentoEmAndamento ? () => redirecionaParaSisPag(candidato.id) : null}
                                  to={!candidato.pagamentoEmAndamento ? { pathname: `/admin/inscricao/${candidato.id}/pagamento/fatura`, state: { candidato: candidato.id }} : null}
                                  component={!candidato.pagamentoEmAndamento ? Link : 'button'}
                                  name={candidato.pagamentoEmAndamento ? "Gerar 2ª Via do Boleto" : "Realizar Pagamento da Inscrição"}
                                  fullWidth
                                />
                              }
                            />
                          }
                        </>
                      : (candidato.comEscolaValida && candidato.comMatriculaValida && candidato.comLocalProvaEscolhido && candidato.precisaRealizarPagamento && candidato.pagamentoConfirmado) &&
                        <DashboardCard
                          title="Pagamento"
                          description="Pagamento confirmado no sistema. Acesse o Sistema de Pagamento para gerar sua Nota Fiscal"
                          icon={<PaymentIcon />}
                          status={"success"}
                          action={
                            <ButtonPrimary
                              startIcon={<ReceiptIcon />}
                              onClick={() => redirecionaParaSisPagDadosPagamento(candidato.id)}
                              name="Ver Dados de Pagamento"
                              fullWidth
                            />
                          }
                        />
                      }

                      {(candidato.podeFinalizarInscricao || candidato.inscricaoFinalizada) && (
                        <DashboardCard
                          title="Finalização da Inscrição"
                          description="Confirme seus dados e finalize sua inscrição para participar."
                          icon={<CheckCircleIcon />}
                          status={candidato.podeGerarRecibo || (candidato.precisaRealizarPagamento && candidato.inscricaoFinalizada) ? "success" : "warning"}
                          action={
                            <ButtonPrimary
                              startIcon={<CheckCircleIcon />}
                              onClick={this.handleOpenDialogFinalizarInscricao}
                              name="Finalizar Inscrição"
                              fullWidth
                            />
                          }
                        />
                      )}

                      {candidato.podeGerarRecibo && (
                        <DashboardCard
                          title="Comprovante de Inscrição"
                          description="Visualize e baixe seu comprovante de inscrição."
                          icon={<DescriptionIcon />}
                          status="success"
                          action={
                            <ButtonPrimary
                              startIcon={<ReceiptIcon />}
                              to={{ pathname: `/admin/inscricao/${candidato.id}/comprovante`, state: { candidato: candidato.id } }}
                              component={Link}
                              name="Gerar Comprovante de Inscrição"
                              fullWidth
                            />
                          }
                        />
                      )}

                      { (isPeriodoConfirmacao(contexts) && candidato.inscricaoFinalizada && candidato.podeGerarRecibo) && (
                        <DashboardCard
                          title="Confirmar Local de Prova"
                          description="Confirme o Município de Prova desejado dentro das opções disponíveis."
                          icon={<CheckCircleIcon />}
                          status={candidato.comLocalProvaConfirmado ? "success" : "warning"}
                          action={
                            <ButtonPrimary
                              startIcon={<EditIcon />}
                              to={{ pathname: `/admin/inscricao/${candidato.id}/local-prova/confirmar`, state: { candidato: candidato.id } }}
                              component={Link}
                              name="Confirmar Município"
                              fullWidth
                            />
                          }
                        />
                      )}

                      <DashboardCard
                        title="Segurança"
                        description="Mantenha seus dados protegidos alterando sua senha."
                        icon={<VpnKeyIcon />}
                        status={null}
                        action={
                          <ButtonDefault
                            startIcon={<LockOutlinedIcon />}
                            onClick={this.handleOpenDialogChangePassword}
                            name="Alterar Senha"
                            fullWidth
                          />
                        }
                      />                    
                    </Grid>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        }

        { (candidato.podeFinalizarInscricao || candidato.inscricaoFinalizada) &&
          <DialogFinalizarInscricao
            parentRef={this.setDialogFinalizarInscricao}
            handleConfirm={this.handleFinalizarInscricao}
          />
        }

        <DialogChangePassword
          parentRef={this.setDialogChangePassword}
          handleAtualizarSenha={CandidatoService.atualizarSenha}
        />        
      </Layout>
    )
  }
}

const mapStateToProps = state => ({ contexts: state.periodos });
const mapDispatchToProps = dispatch => (bindActionCreators({ loadPeriodos }, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Dashboard));
